import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m10 11 4 4m0-4-4 4m-1.6 4C5.418 19 3 16.604 3 13.65 3 11.2 4.8 8.937 7.5 8.5 8.347 6.486 10.351 5 12.69 5c2.994 0 5.442 2.323 5.61 5.25 1.59.695 2.7 2.4 2.7 4.247A4.5 4.5 0 0 1 16.5 19z" }, null, -1)
  ])))
}
export default { render: render }